import React from "react";
import { Row, Col } from "antd";

import { DownSquareFilled, UpSquareFilled } from "@ant-design/icons";
import CountCard from "./CountCard";

const CardStatsKeywords = ({ keywordsObj }) => {
  return (
    <Row>
      <Col
        xl={4}
        lg={4}
        sm={6}
        xs={12}
        key="positiveImpact"
        className="count-keyword-card"
      >
        <CountCard title="Postive Impact" tooltip="">
          <h5 className="mb-0">
            <span style={{ fontSize: "24px" }}>
              {keywordsObj.upImpactKeywordsCount}
            </span>
            <UpSquareFilled
              style={{
                color: "#EE7B7B",
                marginBottom: "5px",
                fontSize: "20px",
                padding: 5,
              }}
            />{" "}
          </h5>
        </CountCard>
      </Col>
      <Col
        xl={4}
        lg={4}
        sm={6}
        xs={12}
        key="negativeImpact"
        className="count-keyword-card"
      >
        <CountCard title="Negative Impact" tooltip="">
          <h5 className="mb-0">
            <span style={{ fontSize: "24px" }}>
              {keywordsObj.downImpactKeywordsCount}{" "}
            </span>
            <DownSquareFilled
              style={{
                color: "#EE7B7B",
                marginBottom: "5px",
                fontSize: "20px",
                padding: 5,
              }}
            />{" "}
          </h5>
        </CountCard>
      </Col>
      <Col
        xl={4}
        lg={4}
        sm={6}
        xs={12}
        key="upKeyword"
        className="count-keyword-card"
      >
        <CountCard title="Up Keyword(s)" tooltip="">
          <h5 className="mb-0">
            <span style={{ fontSize: "24px" }}>
              {keywordsObj.upKeywordsCount}
            </span>
            <UpSquareFilled
              style={{
                color: "#EE7B7B",
                marginBottom: "5px",
                fontSize: "20px",
                padding: 5,
              }}
            />{" "}
            <span style={{ fontSize: "14px", color: "green" }}>
              {(
                (keywordsObj.upKeywordsCount / keywordsObj.totalKeywordsCount) *
                100
              ).toFixed(2)}
              %
            </span>
          </h5>
        </CountCard>
      </Col>
      <Col
        xl={4}
        lg={4}
        sm={6}
        xs={12}
        key="downKeyword"
        className="count-keyword-card"
      >
        <CountCard title="Down Keyword(s)" tooltip="">
          <h5 className="mb-0">
            <span style={{ fontSize: "24px" }}>
              {keywordsObj.downKeywordsCount}
            </span>
            <DownSquareFilled
              style={{
                color: "#EE7B7B",
                marginBottom: "5px",
                fontSize: "20px",
                padding: 5,
              }}
            />{" "}
            <span style={{ fontSize: "14px", color: "red" }}>
              -
              {(
                (keywordsObj.downKeywordsCount /
                  keywordsObj.totalKeywordsCount) *
                100
              ).toFixed(2)}
              %
            </span>
          </h5>
        </CountCard>
      </Col>
      <Col
        xl={4}
        lg={4}
        sm={6}
        xs={12}
        key="noChangeKeyword"
        className="count-keyword-card"
      >
        <CountCard title="Stable Keyword(s)" tooltip="">
          <h5>
            <span style={{ fontSize: "24px" }}>
              {keywordsObj.noChangeKeywordsCount}
            </span>
          </h5>
        </CountCard>
      </Col>
      <Col
        xl={4}
        lg={4}
        sm={6}
        xs={12}
        key="totalKeyword"
        className="count-keyword-card"
      >
        <CountCard title="Total Keyword(s)" tooltip="">
          <h5>
            <span style={{ fontSize: "24px" }}>
              {keywordsObj.totalKeywordsCount}
            </span>
          </h5>
        </CountCard>
      </Col>
    </Row>
  );
};

export default CardStatsKeywords;
